import { metrics } from '@seek/metrics-js';

import type { FormName, FormState } from '../types';

export const handleFormSubmit = <T extends string>(
  promise: Promise<any>,
  setFormState: React.Dispatch<React.SetStateAction<FormState<T>>>,
  formName: FormName,
) => {
  setFormState({ submitted: false, loading: true });

  promise
    .then(() => {
      // login and register events must be tracked in the promise before it redirects
      if (formName !== 'register' && formName === 'login') {
        metrics.count(`form_submit_ok_${formName}`);
        metrics.flush();
      }
      setFormState({ submitted: true, loading: false });
    })
    .catch((error: T) => {
      metrics.count(`form_submit_error_${formName}`);
      setFormState({ submitted: false, loading: false, error });
    });
};
